module.exports = __webpack_public_path__ + "create_project.b59e09ff.mp4";